<template>
  <div>
    <BlocoFiltroPesquisa
      :ordenar-por="['nome']"
      :ordenar-nomes="['Nome']"
      :nome-do-form="nomeDoForm"
      @pesquisar="pesquisar"
      @ordenar="ordenar"
      @novo="novo"
    >
      <template #form>
        <div class="row">
          <div class="col-xs-12 col-sm-10 col-md-10 col-lg-10">
            <CampoNome :valor="filtro.nome" @atualizar="filtro.nome = $event" />
          </div>
          <div class="col-xs-12 col-sm-2 col-md-2 col-lg-2">
            <SelecionarSituacao
              id="ativo"
              :valor="filtro.ativo"
              @atualizar="filtro.ativo = $event"
            />
          </div>
        </div>
      </template>
    </BlocoFiltroPesquisa>
    <BlocoPaginadorPesquisa
      :total="total"
      :modo-resultado="modoResultado"
      @paginaAlterada="paginaAlterada"
      @modoAlterado="modoAlterado"
    />
    <BlocoResultadoPesquisa :total="total" :modo-resultado="modoResultado">
      <template #tabela
        ><FaturamentoTabela
          :faturamentos="faturamentos"
          @glosa="glosaFaturamento"
          @arquivar="arquivarFaturamento"
          @finalizar="finalizarFaturamento"
      /></template>
      <template #fichas>
        <div
          v-for="faturamento in faturamentos"
          :key="faturamento._id"
          class="col-xs-12 col-sm-6 col-md-4 col-lg-3"
        >
          <FaturamentoFicha
            :faturamento="faturamento"
            @glosa="glosaFaturamento"
            @arquivar="arquivarFaturamento"
            @finalizar="finalizarFaturamento"
          />
        </div>
      </template>
    </BlocoResultadoPesquisa>
  </div>
</template>

<script>
import { ref } from 'vue'
import { useRoute, useRouter } from 'vue-router'

import BlocoFiltroPesquisa from '@/componentes/formulario/BlocoFiltroPesquisa'
import BlocoPaginadorPesquisa from '@/componentes/formulario/BlocoPaginadorPesquisa'
import BlocoResultadoPesquisa from '@/componentes/formulario/BlocoResultadoPesquisa'
import CampoNome from '@/componentes/formulario/CampoNome'
import SelecionarSituacao from '@/componentes/formulario/SelecionarSituacao'
import { useMenu } from '@/composables/useMenu'
import { usePesquisa } from '@/composables/usePesquisa'
import FaturamentoServico from '@/servicos/FaturamentoServico'
import GuiaServico from '@/servicos/GuiaServico'

import FaturamentoFicha from './FaturamentoFicha'
import FaturamentoTabela from './FaturamentoTabela'

const guiaServico = new GuiaServico()

export default {
  name: 'Faturamento',
  components: {
    FaturamentoFicha,
    FaturamentoTabela,
    BlocoFiltroPesquisa,
    CampoNome,
    SelecionarSituacao,
    BlocoResultadoPesquisa,
    BlocoPaginadorPesquisa,
  },
  setup() {
    const router = useRouter()
    const route = useRoute()
    const faturamentos = ref([])
    const servico = new FaturamentoServico()
    const nomeResultado = 'faturamentos'
    const nomeDoForm = 'FaturamentoForm'
    const filtro = ref({
      nome: '',
      ativo: '',
    })
    const pesquisa = usePesquisa({
      filtro,
      resultado: faturamentos,
      servico,
      nomeResultado,
      nomeDoForm,
      cacheFormularioAtivo: true,
      onNovo: () => router.replace({ path: route.path + '/cadastro' }),
    })
    useMenu(43)
    return { faturamentos, servico, filtro, ...pesquisa }
  },

  methods: {
    finalizarFaturamento(faturamento) {
      faturamento.finalizado = new Date()
      this.$nextTick()
      this.servico.atualizar(faturamento._id, faturamento).then((res) => {
        faturamento.guias.forEach((guia) => {
          guiaServico.adicionaGuiaFaturada(guia._id)
        })
      })
    },
    glosaFaturamento(faturamento) {
      faturamento.glosa = new Date()
      this.$nextTick()
      this.servico.atualizar(faturamento._id, faturamento).then((res) => {
        faturamento.guias.forEach((guia) => {
          guiaServico.adicionaGuiaGlosa(guia._id)
        })
      })
    },
    arquivarFaturamento(faturamento) {
      faturamento.arquivado = new Date()
      this.$nextTick()
      this.servico.atualizar(faturamento._id, faturamento).then((res) => {
        faturamento.guias.forEach((guia) => {
          guiaServico.adicionaGuiaArquivada(guia._id)
        })
      })
    },
  },
}
</script>
